export function parseTaskDate(value) {
    if (!value) return null;
    const d = new Date(value);
    return Number.isNaN(d.getTime()) ? null : d;
}

export function isDueTodayOrOverdue(task) {
    const due = parseTaskDate(task.due_date);
    if (!due) return true;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const dueDay = new Date(due);
    dueDay.setHours(0, 0, 0, 0);
    return dueDay.getTime() <= today.getTime();
}

export function isDueToday(task) {
    const due = parseTaskDate(task.due_date);
    if (!due) return false;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const dueDay = new Date(due);
    dueDay.setHours(0, 0, 0, 0);
    return dueDay.getTime() === today.getTime();
}

export function isOverdue(task) {
    const due = parseTaskDate(task.due_date);
    if (!due) return false;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const dueDay = new Date(due);
    dueDay.setHours(0, 0, 0, 0);
    return dueDay.getTime() < today.getTime();
}

const PRIORITY_ORDER = { high: 0, medium: 1, low: 2 };

export function sortTasksForStaff(tasks) {
    return [...tasks].sort((a, b) => {
        const pa = PRIORITY_ORDER[a.priority?.toLowerCase()] ?? 1;
        const pb = PRIORITY_ORDER[b.priority?.toLowerCase()] ?? 1;
        if (pa !== pb) return pa - pb;
        const da = parseTaskDate(a.due_date)?.getTime() ?? Infinity;
        const db = parseTaskDate(b.due_date)?.getTime() ?? Infinity;
        return da - db;
    });
}

export function formatDueLabel(task) {
    const due = parseTaskDate(task.due_date);
    if (!due) return null;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const dueDay = new Date(due);
    dueDay.setHours(0, 0, 0, 0);
    if (dueDay.getTime() === today.getTime()) return "Today";
    if (dueDay.getTime() < today.getTime()) return "Overdue";
    return due.toLocaleDateString("en-GB", { day: "numeric", month: "short" });
}
